<template>
  <div>Electronic VIT</div>
</template>

<script>

  export default {
    name: "ElectronicVIT",
    components: {
    },
    data () {
      return {
      }
    },
    created() {     
    },
    mounted() {
    },
    methods: {
    },
    watch:
    {
    }

  }

</script>

<style scoped>

</style>
